import React, { useEffect } from "react";
import "./workspaces.css";
import "../../../../Styles/hometaskbar.css";
import Workspace from "./Workspace/Workspace";
import { CircularProgress } from "@material-ui/core";
// import { Statecontext } from "../../../../context/DataProvider";
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllWorkspaces } from '../../../../actions/workspaceActions'

function Workspaces() {
  // const state = useContext(Statecontext)[0];
  const dispatch = useDispatch();
  const allWorkspaces = useSelector(state => state.allWorkspaces);
  const { loading, error, workspaceDetails } = allWorkspaces;

  useEffect(() => {
    if (!workspaceDetails) {
      dispatch(fetchAllWorkspaces());
    }
  }, [workspaceDetails])

  return (
    <div className="workspaces">
      {" "}
      <div className="workspaces__taskbar">
        {" "}
        <div className="mainlayout__taskbar">
          <h1 style={{ fontSize: "1.8rem" }}>Workspaces</h1>
        </div>
      </div>
      <div className="workspaces__container">
        {loading ? <CircularProgress /> : error ? <h3>{error}</h3> : workspaceDetails?.map((item) => {
          return <Workspace item={item} />;
        })}
      </div>
    </div>
  );
}

export default Workspaces;
